<template>

  <div>
    <b-form-group
      :label="$t('urbanStudy.DataSourceInfos')"
      class="medium-label mb-0"
      label-for="dataSourceInfos-input">
    </b-form-group>
    <div class="multi-tabs-field-container mb-4">

      <div class="col">
        <b-nav class="multi-tabs-field-navbar">
          <b-nav-item v-for="(dataSource, index) in dataSources" :key="index + '-nav-key'"
                      :class="{ 'link-active': currentSection === index }"
                      class="multi-tabs-field-navbar-item"
                      @click.prevent="currentSection = index">
            {{ $t(dataSource.text) }}
          </b-nav-item>
        </b-nav>
      </div>

      <b-container fluid>
        <b-row>

          <b-col v-for="(dataSource, index) in dataSources" v-if="currentSection === index"
                 :key="index + '-content-key'">
            <div class="mb-4">
              <div class="d-flex pb-4">
                <div class="data-source-link-label">{{ $t('dataSourceEnum.Link') }} :</div>
                <a :href="dataSource.link" class="data-source-link-value" target="_blank">{{ dataSource.link }}</a>
              </div>

              <div>
                <div class="bold-text ">
                  {{ $t('dataSourceInfo.Comment') }}
                </div>
                <div class="mt-2" v-html="formatNewlines(tabInfoByDataSourceValues[dataSource.value].comment)">
                </div>
              </div>
            </div>
          </b-col>

        </b-row>
      </b-container>

    </div>
  </div>

</template>

<script>

import api from '../../services/api'

export default {

  name: "DataSourceInfoMultiTabsEditField",

  props: {
    urbanStudyId: null,
  },

  data() {
    return {
      currentSection: null,

      dataSources: [],
      dataSourceInfos: [],
      tabInfoByDataSourceValues: {}
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    formatNewlines(text) {
      if (!text) return '';
      return text.replace(/\n/g, '<br>');
    },

    async fetchData() {
      await this.fetchDataSources()
      if (this.urbanStudyId) {
        await this.fetchDataSourceInfos()
      }
      this.currentSection = 0
    },

    async fetchDataSources() {
      await api
        .get(`/dataSourceInfo/getDataSources`)
        .then(response => {
          this.dataSources = response.data
          this.initDataStructure()
        })
    },

    async initDataStructure() {
      for (let dataSource of this.dataSources) {
        this.tabInfoByDataSourceValues[dataSource.value] = {comment: null}
      }
    },

    async fetchDataSourceInfos() {
      await api
        .get(`/dataSourceInfo/getDataSourceInfos/${this.urbanStudyId}`)
        .then(response => {
          this.dataSourceInfos = response.data.filter(item => item)
        })

      for (let dataSourceInfo of this.dataSourceInfos) {
        this.tabInfoByDataSourceValues[dataSourceInfo.dataSource.value].comment = dataSourceInfo.comment
      }
    },

  },

}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/urbanStudy/DataSourceInfoMultiTabsShowField.vue